export default __webpack_public_path__ + "static/media/logo.d421ce28.svg";